import { h } from 'preact';
import styles from './SearchResultsHeader.module.scss';
export function SearchResultsHeader({ query, totalResults, activeTab, onTabChange, productCount = 0, articleCount = 0, pageCount = 0, showTabs = true, }) {
    return (h("div", { class: styles.searchResultsHeader },
        h("h1", { class: styles.searchTitle },
            "Search Results: ",
            h("span", { class: styles.query }, query),
            h("span", { class: styles.resultCount },
                "[",
                totalResults,
                "]")),
        showTabs && h("div", { class: styles.tabsContainer },
            h("button", { class: `${styles.tab} ${activeTab === 'products' ? styles.activeTab : ''}`, onClick: () => onTabChange('products') },
                "PRODUCTS ",
                productCount > 0 && `(${productCount})`),
            h("button", { class: `${styles.tab} ${activeTab === 'articles' ? styles.activeTab : ''}`, onClick: () => onTabChange('articles') },
                "ARTICLES ",
                articleCount > 0 && `(${articleCount})`),
            h("button", { class: `${styles.tab} ${activeTab === 'pages' ? styles.activeTab : ''}`, onClick: () => onTabChange('pages') },
                "PAGES ",
                pageCount > 0 && `(${pageCount})`))));
}
